import { useState } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function Memberships() {
  const [selectedMembership, setSelectedMembership] = useState(null);
  const [riders, setRiders] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [showPurchaseForm, setShowPurchaseForm] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    country: 'Pakistan',
    address: '',
    city: '',
    province: '',
    postalCode: ''
  });

  const memberships = {
    riding: {
      title: '2026 RIDING MEMBERSHIP',
      price: 'from PKR 119,025',
      description: 'Get ready for another epic season at Throttle Edge! Your 2026 Riding Membership gives you unlimited riding access to all tracks and trails during regular operating hours from opening day until the end of the season.'
    },
    camping: {
      title: '2026 CAMPING MEMBERSHIP',
      price: 'PKR 123,165',
      description: 'Get ready for another epic season at Throttle Edge! Your 2026 Camping Membership gives you unlimited camping access during regular operating hours from opening day until the end of the season.'
    },
    vehicle: {
      title: '2026 ADDITIONAL VEHICLE MEMBERSHIP',
      price: 'PKR 41,193',
      description: 'Add an additional vehicle to your membership for convenient access to Throttle Edge facilities.'
    }
  };

  const openModal = (type) => {
    setSelectedMembership(type);
    setRiders('');
    setQuantity(1);
  };

  const closeModal = () => {
    setSelectedMembership(null);
    setShowPurchaseForm(false);
  };

  const handlePurchase = () => {
    setShowPurchaseForm(true);
  };

  const handleBackToQuickView = () => {
    setShowPurchaseForm(false);
  };

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Membership purchase submitted!');
    closeModal();
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <div className="relative h-[40vh] md:h-[60vh] mt-16 md:mt-24">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(/a13.jpg)',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        </div>
      </div>

      <div className="py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h1 className="text-4xl md:text-6xl text-center uppercase italic tracking-[0.2em] md:tracking-[0.3em] mb-6 font-light">
            2026 MEMBERSHIPS
          </h1>
          
          <p className="text-center font-bold text-lg mb-12" style={{ color: '#F5A623' }}>
            For Bookings: <a href="mailto:bookings@throttledge.com" className="text-red-600 hover:underline">bookings@throttledge.com</a>
          </p>

          {/* Membership Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {/* 2026 Riding Membership */}
            <div className="text-center">
              <div className="bg-white border-2 border-gray-300 p-8 mb-6 min-h-[400px] flex flex-col justify-center">
                <div className="mb-6">
                  <img 
                    src="/throttle.png" 
                    alt="Throttle Edge Logo" 
                    className="w-48 h-auto mx-auto mb-4"
                  />
                </div>
                <h2 className="text-5xl md:text-6xl font-black uppercase mb-2" style={{ color: '#F5A623' }}>
                  2026
                </h2>
                <h2 className="text-4xl md:text-5xl font-black uppercase mb-6" style={{ color: '#F5A623' }}>
                  RIDING<br/>MEMBERSHIP
                </h2>
                <button 
                  onClick={() => openModal('riding')}
                  className="bg-black text-white px-8 py-3 uppercase text-sm font-bold tracking-widest hover:bg-gray-800 transition-colors"
                >
                  QUICK VIEW
                </button>
              </div>
              <h3 className="text-xl font-semibold mb-2">2026 Riding Membership</h3>
              <p className="text-gray-600">from PKR 119,025</p>
            </div>

            {/* 2026 Camping Membership */}
            <div className="text-center">
              <div className="bg-white border-2 border-gray-300 p-8 mb-6 min-h-[400px] flex flex-col justify-center">
                <div className="mb-6">
                  <img 
                    src="/throttle.png" 
                    alt="Throttle Edge Logo" 
                    className="w-48 h-auto mx-auto mb-4"
                  />
                </div>
                <h2 className="text-5xl md:text-6xl font-black uppercase mb-2" style={{ color: '#F5A623' }}>
                  2026
                </h2>
                <h2 className="text-4xl md:text-5xl font-black uppercase mb-6" style={{ color: '#F5A623' }}>
                  CAMPING<br/>MEMBERSHIP
                </h2>
                <button 
                  onClick={() => openModal('camping')}
                  className="bg-black text-white px-8 py-3 uppercase text-sm font-bold tracking-widest hover:bg-gray-800 transition-colors"
                >
                  QUICK VIEW
                </button>
              </div>
              <h3 className="text-xl font-semibold mb-2">2026 Camping Membership</h3>
              <p className="text-gray-600">PKR 123,165</p>
            </div>

            {/* 2026 Additional Vehicle Membership */}
            <div className="text-center">
              <div className="bg-white border-2 border-gray-300 p-8 mb-6 min-h-[400px] flex flex-col justify-center">
                <div className="mb-6">
                  <img 
                    src="/throttle.png" 
                    alt="Throttle Edge Logo" 
                    className="w-48 h-auto mx-auto mb-4"
                  />
                </div>
                <h2 className="text-5xl md:text-6xl font-black uppercase mb-2" style={{ color: '#F5A623' }}>
                  2026
                </h2>
                <h2 className="text-3xl md:text-4xl font-black uppercase mb-6" style={{ color: '#F5A623' }}>
                  ADDITIONAL<br/>VEHICLE<br/>MEMBERSHIP
                </h2>
                <button 
                  onClick={() => openModal('vehicle')}
                  className="bg-black text-white px-8 py-3 uppercase text-sm font-bold tracking-widest hover:bg-gray-800 transition-colors"
                >
                  QUICK VIEW
                </button>
              </div>
              <h3 className="text-xl font-semibold mb-2">2026 Additional Vehicle Membership</h3>
              <p className="text-gray-600">PKR 41,193</p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedMembership && !showPurchaseForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto relative">
            {/* Close Button */}
            <button 
              onClick={closeModal}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-3xl font-light"
            >
              ×
            </button>

            <div className="p-8">
              {/* Left Side - Image/Logo */}
              <div className="flex flex-col md:flex-row gap-8">
                <div className="md:w-1/2">
                  <div className="bg-white border-2 border-gray-300 p-8">
                    <svg className="w-full h-48" viewBox="0 0 300 200">
                      <text x="150" y="80" textAnchor="middle" className="text-4xl font-bold fill-black">THROTTLE EDGE</text>
                      <text x="150" y="140" textAnchor="middle" className="text-6xl font-bold" fill="#F5A623">2026</text>
                      <text x="150" y="170" textAnchor="middle" className="text-3xl font-bold" fill="#F5A623">
                        {selectedMembership === 'riding' ? 'RIDING' : selectedMembership === 'camping' ? 'CAMPING' : 'VEHICLE'}
                      </text>
                    </svg>
                  </div>
                </div>

                {/* Right Side - Details */}
                <div className="md:w-1/2">
                  <h2 className="text-3xl font-bold uppercase mb-2 italic" style={{ color: '#F5A623' }}>
                    {memberships[selectedMembership].title}
                  </h2>
                  <p className="text-gray-600 mb-4">{memberships[selectedMembership].price}</p>
                  
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    {memberships[selectedMembership].description}
                  </p>

                  {/* Quantity */}
                  <div className="mb-6">
                    <label className="block text-sm font-semibold mb-2">Quantity:</label>
                    <input 
                      type="number" 
                      min="1"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                      className="w-full border-2 border-gray-300 p-3 text-gray-700"
                    />
                  </div>

                  {/* Purchase Button */}
                  <button 
                    onClick={handlePurchase}
                    className="w-full bg-black text-white py-4 uppercase text-sm font-bold tracking-widest hover:bg-gray-800 transition-colors"
                  >
                    Purchase Membership
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Purchase Form Modal */}
      {showPurchaseForm && selectedMembership && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto relative">
            {/* Back Button (Cross) */}
            <button 
              onClick={handleBackToQuickView}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-3xl font-light z-10"
              title="Back to Quick View"
            >
              ×
            </button>

            <div className="p-8">
              <h2 className="text-2xl font-bold mb-6 text-center">
                {memberships[selectedMembership].title} Form
              </h2>

              <form onSubmit={handleFormSubmit}>
                {/* Name */}
                <div className="mb-4">
                  <label className="block text-sm font-semibold mb-2">Name (required)</label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleFormChange}
                        required
                        className="w-full border-2 border-gray-300 p-3 text-gray-700"
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleFormChange}
                        required
                        className="w-full border-2 border-gray-300 p-3 text-gray-700"
                      />
                    </div>
                  </div>
                </div>

                {/* Phone */}
                <div className="mb-4">
                  <label className="block text-sm font-semibold mb-2">Phone (required)</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleFormChange}
                    required
                    className="w-full border-2 border-gray-300 p-3 text-gray-700"
                  />
                </div>

                {/* Email */}
                <div className="mb-4">
                  <label className="block text-sm font-semibold mb-2">Email (required)</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleFormChange}
                    required
                    className="w-full border-2 border-gray-300 p-3 text-gray-700"
                  />
                </div>

                {/* Address */}
                <div className="mb-4">
                  <label className="block text-sm font-semibold mb-2">Address (required)</label>
                  
                  {/* Country */}
                  <div className="mb-3">
                    <label className="block text-xs text-gray-600 mb-1">Country</label>
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleFormChange}
                      className="w-full border-2 border-gray-300 p-3 text-gray-700"
                    >
                      <option value="Pakistan">Pakistan</option>
                      <option value="United States">United States</option>
                      <option value="Pakistan">Pakistan</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  {/* Street Address */}
                  <div className="mb-3">
                    <input
                      type="text"
                      name="address"
                      placeholder="Street Address"
                      value={formData.address}
                      onChange={handleFormChange}
                      required
                      className="w-full border-2 border-gray-300 p-3 text-gray-700"
                    />
                  </div>

                  {/* City, Province, Postal Code */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <input
                      type="text"
                      name="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleFormChange}
                      required
                      className="w-full border-2 border-gray-300 p-3 text-gray-700"
                    />
                    <input
                      type="text"
                      name="province"
                      placeholder="Province"
                      value={formData.province}
                      onChange={handleFormChange}
                      required
                      className="w-full border-2 border-gray-300 p-3 text-gray-700"
                    />
                    <input
                      type="text"
                      name="postalCode"
                      placeholder="Postal Code"
                      value={formData.postalCode}
                      onChange={handleFormChange}
                      required
                      className="w-full border-2 border-gray-300 p-3 text-gray-700"
                    />
                  </div>
                </div>

                {/* Quantity */}
                <div className="mb-6">
                  <label className="block text-sm font-semibold mb-2">Quantity:</label>
                  <input 
                    type="number" 
                    min="1"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                    className="w-full border-2 border-gray-300 p-3 text-gray-700"
                  />
                </div>

                {/* Submit Button */}
                <button 
                  type="submit"
                  className="w-full bg-black text-white py-4 uppercase text-sm font-bold tracking-widest hover:bg-gray-800 transition-colors"
                >
                  Submit Purchase
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default Memberships;
